import { useState } from 'react';
import config from '../config';
import { useSession } from '../contexts/SessionContext';

interface FilterCriteria {
  ean: string;
}

const useSearchEan = (filterCriteria: FilterCriteria) => {
  const [error, setError] = useState<string | null>(null);
  const { sessionState } = useSession();

  const searchEan = async (searchTerm: string) => {
    if (!searchTerm || searchTerm.length < 2) return [];
    try {
      const token = sessionState.account?.token;
      const response = await fetch(`${config.centralApiBaseUrl}/device/search/${searchTerm}`, {
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch items');
      }

      const data = await response.json();
      return data;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unknown error occurred');
      return [];
    }
  };

  return { searchEan, error };
};

export default useSearchEan;
